<template>
  <div id="introduce">
    <div class="box" ref="box">
      <div class="partone">
        <div class="innerBox" @click="goDetail('关于我们', 'aboutUs')">
          <div class="logo"></div>
          <p class="name slide">中消在线</p>
          <div class="box">
            <p class="introduce slide">全球领先应急安全综合服务平台</p>
            <p class="introduce slide">数字化建设综合服务商</p>
            <p class="know slide">了解我们</p>
          </div>
          <!-- <div class="more slide" @click="scroll"></div> -->
        </div>
      </div>
      <div class="parttwo" id="start">
        <ul class="part">
          <li @click="goDetail(item.name, item.type)" :class="['item', item.type, item.src == '' ? 'blank' : '']"
            v-for="(item, index) in partList" :key="index">
            <p v-show="item.src == ''" class="title">{{ item.title }}</p>
            <img v-show="item.src != ''" :src="item.src" alt="">
          </li>
        </ul>
      </div>
    </div>
    <server></server>
  </div>
</template>

<script>
import server from './component/server.vue'
import wxShare from '../../wx/weixin'
export default {
  components: {
    server
  },
  data () {
    return {
      partList: [
        {
          name: '安全管家',
          src: require('./images/aq.png'),
          type: 'safeManager'
        },
        {
          name: '城市数字化建设',
          src: require('./images/xfy.png'),
          type: 'xfy'
        },
        {
          name: '中消商城',
          src: require('./images/sc.png'),
          type: 'mall'
        },
        {
          name: '线下消防一体化',
          src: require('./images/jslogo.png'),
          type: 'construction'
        },
        {
          name: '中消救援',
          src: require('./images/jy.png'),
          type: 'save'
        },
        {
          name: '在线培训',
          src: require('./images/trainlogo.png'),
          type: 'train'
        },
        {
          name: '中消集团',
          title: '中消集团',
          src: require('./images/jtlogo.png'),
          type: 'jt'
        }
      ],
      bannerImage: '',
      imgList: [require('../../assets/kepu.png'), require('../../assets/jinsheng.png'), require('../../assets/dingzhi.png')],
      images: [
        require('../../assets/icon-training1.png'),
        require('../../assets/icon-training2.png'),
        require('../../assets/icon-training3.png'),
        require('../../assets/icon-training4.png')],
      videos: [
        { 'id': '1', 'title': '装修不要使用易燃材料', 'video': 'http://video.zxzx119.com/6767cfa6e78c4768bba820236a4ddcd8/1ed40d31c75540f090640c25bae223c9-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../../assets/icon_video1.jpg') },
        { 'id': '1', 'title': '油锅着火怎么办', 'video': 'http://video.zxzx119.com/b065bec910004ea394e7920b4088635c/5a30bb3fe6ba4183a3aa0e1be7319055-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../../assets/icon_video2.jpg') },
        { 'id': '1', 'title': '煨汤无人看管会失火', 'video': 'http://video.zxzx119.com/ec11b55be77e425c96d594fc38be592d/4aaa709346204182a5f4a5ef6a558e8e-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../../assets/icon_video3.jpg') },
        { 'id': '1', 'title': '天然气着火怎么办', 'video': 'http://video.zxzx119.com/b4fa1e8ece2f4df7862e3f73afe51bab/c561800fe32a4eefb09a23044599b1a5-0a6f75c98024abc25e29cea6dec34528.mp4', 'image': require('../../assets/icon_video4.jpg') }

      ],
      videoHtml: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log(from.name == null)
    next(vm => {
      if (from.name == null) {
        window.sessionStorage.setItem('position', JSON.stringify(0))
      }
    })
  },
  // beforeRouteLeave (to, from, next) {
  //   // 保存离开页面时的位置
  //   console.log(document.querySelector('.box'))

  //   next()
  // },
  activated () {
    const position = JSON.parse(window.sessionStorage.getItem('position'))
    console.log(position)
    this.$refs.box.scrollTop = position
    console.log(this.$refs.box.scrollTop)
  },
  mounted () {
    wxShare.wxRegister('中消在线', '全球领先应急安全综合服务平台', 'http://cdn.zxzx119.com/39073939414056960')
    setTimeout(() => {
      this.startSlide()
    }, 1000)
  },
  created () {
    this.loadBanner()
  },
  methods: {
    loadBanner: function () { // 获取banner图
      var _this = this
      this.utils.GET(this.accountUrl + '/adb/getList?type=12',
        function (data) {
          let result = data.data[0]
          _this.bannerImage = result.ad_file
        })
    },
    scroll () {
      // window.scrollTo({
      //   top: 100,
      //   behavior: 'smooth' // 平滑滚动
      // })
      console.log('点了')
      console.log(document.getElementById('start'))
      document.getElementById('start').offsetTop = 500
    },
    goDetail (name, type) {
      const position = this.$refs.box.scrollTop
      window.sessionStorage.setItem('position', JSON.stringify(position))
      console.log(this.$refs.box.scrollTop)
      console.log(position)
      this.$router.push({
        path: '/inHomeDetail',
        query: {
          type: type,
          title: name
        }
      })
    },
    startSlide () {
      let DomList = [...document.querySelectorAll('.slide')]
      for (let n = 0; n < DomList.length; n++) {
        setTimeout(() => {
          DomList[n].classList.remove('slide')
          DomList[n].classList.add('slideUp')
        }, n * 200)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  font-size: 0;
}

@font-face {
  font-family: hero;
  src: url('./ysz.ttf') format('truetype');
}

@keyframes out {

  0%,
  10% {
    opacity: 1;
    transform: translateX(-5px);
  }

  20% {
    opacity: 0.8;
  }

  40% {
    opacity: 0.6;
  }

  60% {
    opacity: 0.4;
  }

  80% {
    opacity: 0.2;
  }

  100% {
    opacity: 0;
    transform: translateX(375px);
  }
}

@keyframes arrow {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(12px);
  }
}

.hide {
  animation: out 0.8s ease-in forwards;
}

#introduce {
  display: inline-block;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url('./images/bk1.png')no-repeat center top, #000000;
  background-size: contain;
  // background-attachment: fixed;
  // padding-top: 52px;

  .slide {
    margin-top: 150px;
    visibility: visible;
    opacity: 0;
    transition: all 0s;
    -webkit-transition: all 0s;
    -ms-transition: all 0s;
    -moz-transition: all 0s;
  }

  .slideUp {
    margin-top: 0px;
    opacity: 1;
    transition: all 0.6s;
    -webkit-transition: all 0.6s;
    -ms-transition: all 0.6s;
    -moz-transition: all 0.6s;
    transition-delay: 0.5s;
    -moz-transition-delay: 0.5s;
    -webkit-transition-delay: 0.5s;
  }

  .box {
    display: inline-block;
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .partone {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100vh;

    // background: url('./images/fireman.png')no-repeat right bottom;
    // padding-top: 65%;
    // padding-left: 26px;
    // background: url('./images/2part.png')no-repeat center center;
    // background-size: 100% 100%;
    .innerBox {
      position: absolute;
      height: 50%;
      width: 100%;
      bottom: 0;
      left: 0;
      text-align: center;
      padding-top: 30px;

      .logo {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 110.5px;
        height: 93.5px;
        background: url('./images/logo.png')no-repeat center center;
        background-size: 100%;
      }

      .name {
        top: 140px;
        position: absolute;
        width: 100%;
        text-align: center;
        font-family: SourceHanSansCN-Medium;
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 15px;
        vertical-align: text-bottom;
      }

      .box {
        position: absolute;
        width: 100%;
        height: 130px;
        text-align: center;
        top: 200px;
        left: 0;

        .introduce {
          // position: absolute;
          font-family: SourceHanSansCN-Regular;
          font-size: 15px;
          color: #ffffff;
          text-align: center;
          margin-bottom: 5px;
        }

        .know {
          position: relative;
          font-size: 15px;
          color: #ffffff;
          text-align: center;
          margin-top: 30px;

          &::before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-left: 10px solid #fff;
            border-right: 10px solid transparent;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            animation: arrow 1s infinite;
            bottom: 2px;
            left: -90px;
            right: 0;
            margin: 0 auto;
          }
        }
      }

      .more {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 10px solid #fff;
        border-right: 10px solid transparent;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        animation: arrow 1s infinite;
        bottom: 130px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }

  }

  .parttwo {
    position: relative;
    width: 100%;
    height: auto;
    background: url('./images/bk1_1.png')no-repeat center top, #192A48;
    background-size: contain;
    padding: 98px 16px;

    .part {
      display: inline-block;
      list-style: none;
      width: 100%;
      height: 100%;

      .item {
        display: inline-block;
        font-size: 16px;
        width: 100%;
        // height: 200px;
        line-height: 30px;
        padding: 34px 0 29px 0;
        color: #ffffff;
        border-radius: 5px;
        text-align: center;
        margin-bottom: 20px;

        &.blank {
          background: #a7a7a7;
        }

        .title {
          display: inline-block;
          width: 100%;
          height: 130px;
          line-height: 130px;
          font-size: 28px;
          color: #ffffff;
          text-align: center;
        }

        img {
          width: 182px;
          height: 138px;
        }

        &.safeManager {
          background: url("./images/aqbg.png")no-repeat center center, #d0a470;
          background-size: cover;

          img {
            width: 166px;
          }
        }

        &.xfy {
          background: url("./images/xfybg.png")no-repeat center center, #d0a470;
          background-size: cover;

          img {
            width: 205px;
          }
        }

        &.mall {
          background: url("./images/scbj.png")no-repeat center center, #d0a470;
          background-size: cover;
        }

        &.construction {
          background: url("./images/js.png")no-repeat center center, #d0a470;
          background-size: cover;

          img {
            width: 160px;
          }
        }

        &.save {
          background: url("./images/jybj.png")no-repeat center center, #d0a470;
          background-size: cover;
        }

        &.train {
          background: url("./images/train.png")no-repeat center center, #d0a470;
          background-size: cover;

          img {
            width: 166px;
            height: 130px;
          }
        }

        &.jt {
          background: url("./images/jtbg.png")no-repeat center center, #d0a470;
          background-size: cover;

          img {
            width: 190px;
            height: 140px;
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/introduce/homePage.vue